<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import FilterBar from './FilterBar'
	import Actions from './Actions'
	import VueElementLoading from 'vue-element-loading'
	import _ from 'lodash'
	
	export default {
		props: ['isAuth', 'user'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			'filter-bar': FilterBar,
			'loading': VueElementLoading,
			'actions': Actions,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/providers/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							unavalible: false,
						},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:email',
							title: 'E-mail',
							sortField: 'email',
						},
						{
							name: '__slot:mobiles',
							title: 'Teléfono',
							sortField: 'mobile',
						},
						{
							name: '__slot:places',
							title: 'Localización',
						},
						{
							name: '__slot:status',
							title: 'Estado',
						},
						{
							name: '__slot:author',
							title: 'Autor',
							sortField: 'author_id',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},
			}
		},
		created() {
			this.init()
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		methods: {
			init() {
				this.loadQuery()
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			destroy (item) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/providers/' + item.id)
							.then(response => {
								that.reload()
								swal({
									'title': response.body.title,
									'text': response.body.text,
									'type': response.body.type,
								})
							}).catch(function(response) {
								that.$refs.datatable.reload()
								if(response.status = 409) {
									swal({
										'title': response.body.title,
										'text': response.body.text,
										'type': response.body.type,
									})
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/Datatable.vue